<i18n
  src="@/locales/components/views/agro_exporter/production/basic_container_export/uploader_attachment.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<template>
  <upload-button @click.prevent="open = true" :label="$t('labels.title')" />
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" @close="close">
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          />
        </TransitionChild>

        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div class="panel-modal">
            <div class="panel-modal-close">
              <button type="button" class="panel-modal-close" @click="close">
                <span class="sr-only">Close</span>
                <i class="h-6 w-6 fa-solid fa-xmark"></i>
              </button>
            </div>

            <div class="panel-header-title">
              {{ $t("labels.title") }}
            </div>

            <alert-danger :errors_data="std_err" />

            <div class="panel-modal-body">
              <div class="space-y-8 divide-gray-200">
                <div class="space-y-4">
                  <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                    <div
                      class="sm:col-span-6"
                      v-if="exportation_id && exportation_files"
                    >
                      <label class="label-form">
                        {{
                          $t(
                            "model.exportation.exportation_attachments.exporter_process_exportation_file"
                          )
                        }}
                      </label>
                      <div class="mt-1">
                        <select-form
                          v-if="exportation_files.length > 1"
                          :options="exportation_files"
                          v-model="file_id"
                        />
                        <p v-else-if="exportation_files.length == 1">
                          {{ exportation_files[0].name }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="sm:col-span-6"
                      v-if="container_id && container_files"
                    >
                      <label class="label-form">
                        {{
                          $t(
                            "model.container.container_attachments.exporter_process_container_file"
                          )
                        }}
                      </label>
                      <div class="mt-1">
                        <select-form
                          v-if="container_files.length > 1"
                          :options="container_files"
                          v-model="file_id"
                        />
                        <p v-else-if="container_files.length == 1">
                          {{ container_files[0].name }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="flex items-center justify-center w-full">
                    <label
                      @dragover="dragover"
                      @dragleave="dragleave"
                      @drop="drop"
                      for="dropzone-file"
                      class="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                    >
                      <div
                        class="flex flex-col items-center justify-center pt-5 pb-6"
                      >
                        <i
                          :class="[
                            'fa-solid  fa-2xl w-10 h-10 mb-3 ',
                            attach?.name
                              ? 'fa-cloud-arrow-up text-lime-600'
                              : 'fa-cloud-plus text-gray-400'
                          ]"
                        ></i>
                        <p
                          v-show="!attach?.name"
                          class="mb-2 text-sm text-gray-500 dark:text-gray-400"
                        >
                          <span class="font-semibold">
                            {{ $t("labels.click_to_upload") }}
                          </span>
                          <span>{{ $t("labels.drag_and_drop_file") }}</span>
                        </p>
                        <p
                          v-show="attach?.name"
                          class="text-sm text-gray-500 dark:text-gray-400"
                        >
                          <span class="font-semibold">
                            {{ attach?.name }}
                          </span>
                        </p>
                      </div>
                      <input
                        id="dropzone-file"
                        type="file"
                        class="hidden"
                        ref="attach"
                        @change="setAttach"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="panel-modal-footer">
              <div class="panel-footer-actions">
                <white-button
                  @click.prevent="close()"
                  :label="$t('labels.close_button')"
                />
                <span class="space-actions"></span>
                <success-button
                  v-if="!proc_save_button"
                  @click.prevent="submit()"
                  :label="$t('labels.upload_button')"
                />
                <success-button-processing
                  v-else
                  :label="$t('labels.upload_button')"
                />
              </div>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import BasicContainerExportMCRequester from "@/views/agro_exporter/requesters/production/basic_container_export/manage_container.js";
import BasicContainerExportMERequester from "@/views/agro_exporter/requesters/production/basic_container_export/manage_exportation.js";

import {
  Dialog,
  DialogOverlay,
  TransitionChild,
  TransitionRoot
} from "@headlessui/vue";

export default {
  name: "UploaderAttachment",
  components: {
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot
  },
  props: [
    "container_id",
    "exportation_id",
    "exporter_process_container_file_id",
    "exporter_process_exportation_file_id",
    "exportation_files",
    "container_files"
  ],
  data() {
    return {
      open: false,
      attach: null,
      container: null,
      file_id: null,
      proc_save_button: false
    };
  },
  watch: {
    exportation_files: {
      handler: function (exportation_files) {
        if (!exportation_files) return;

        if (exportation_files.length == 1) {
          this.file_id = exportation_files[0].id;
        }
      },
      immediate: true,
      deep: true
    },
    container_files: {
      handler: function (container_files) {
        if (!container_files) return;

        if (container_files.length == 1) {
          this.file_id = container_files[0].id;
        }
      },
      immediate: true,
      deep: true
    }
  },
  emits: ["new"],
  methods: {
    submit: async function () {
      this.proc_save_button = true;
      try {
        let response = null;
        if (this.container_id) {
          response =
            await BasicContainerExportMCRequester.createContainerAttachment(
              this.container_id,
              this.file_id,
              this.attach
            );
        }
        if (this.exportation_id) {
          response =
            await BasicContainerExportMERequester.createExportationAttachment(
              this.exportation_id,
              this.file_id,
              this.attach
            );
        }

        if (response.status == 200) {
          this.registerSuccessNotification({
            title: response.data.success_message
          });
          if (this.container_id) {
            this.$emit("new", JSON.parse(response.data.container_attachment));
          }
          if (this.exportation_id) {
            this.$emit("new", JSON.parse(response.data.exportation_attachment));
          }
        }
        this.close();
      } catch (error) {
        this.loadStandardErrorMessages({
          title: error.response.data.error_title,
          messages: error.response.data.error_messages,
          fields: error.response.data.error_fields
        });
      }
      this.proc_save_button = false;
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains("bg-lime-200")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-lime-200");
      }
    },
    dragleave(event) {
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-lime-200");
    },
    drop(event) {
      event.preventDefault();
      let files = event.dataTransfer.files;
      this.attach = files[0];
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-lime-200");
    },
    setAttach: function () {
      if (this.$refs.attach) this.attach = this.$refs.attach.files[0];
    },
    close: function () {
      this.std_err.display = false;
      this.attach = null;
      this.file_id = null;
      this.open = false;
    }
  }
};
</script>
